import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { SafePipe } from './safe.pipe';

import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSelectModule } from 'ngx-select-ex';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { NgChartsModule } from 'ng2-charts';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DefaultComponent } from './default/default.component';
import { LoginComponent } from './popups/login/login.component';
import { HeaderComponent } from './header/header.component';
import { LanguageConfigComponent } from './pages/language-config/language-config.component';
import { LanguageComponent } from './popups/language/language.component';
import { LanguageSelectionComponent } from './popups/language-selection/language-selection.component';
import { CreateAccountComponent } from './popups/create-account/create-account.component';
import { LanguageContentsAllComponent } from './pages/language-contents-all/language-contents-all.component';
import { LanguagesContentComponent } from './popups/languages-content/languages-content.component';
import { MessageComponent } from './popups/message/message.component';
import { LanguageSectionConfigComponent } from './pages/language-section-config/language-section-config.component';
import { OtpContainerComponent } from './shared/otp-container/otp-container.component';
import { PwdChangeComponent } from './shared/pwd-change/pwd-change.component';
import { StartupComponent } from './pages/startup/startup.component';
import { LanguageContainerComponent } from './shared/language-container/language-container.component';
import { MenusComponent } from './pages/menus/menus.component';
import { MenuConfigurationComponent } from './popups/menu-configuration/menu-configuration.component';
import { CountriesComponent } from './pages/countries/countries.component';
import { CountryConfigurationComponent } from './popups/country-configuration/country-configuration.component';
import { LocationsComponent } from './pages/locations/locations.component';
import { LocationConfigurationComponent } from './popups/location-configuration/location-configuration.component';
import { SellerComponent } from './pages/seller/seller.component';
import { GeneralConfigurationComponent } from './pages/general-configuration/general-configuration.component';
import { GeneralConfigurationPopupComponent } from './popups/general-configuration-popup/general-configuration-popup.component';
import { SellersComponent } from './pages/sellers/sellers.component';
import { MappingContainerComponent } from './shared/mapping-container/mapping-container.component';
import { LocalLocationsComponent } from './shared/local-locations/local-locations.component';
import { UserAuthenticationComponent } from './popups/user-authentication/user-authentication.component';
import { ProductsComponent } from './pages/products/products.component';
import { BillingComponent } from './pages/billing/billing.component';
import { SumPipe } from './pipes/sum.pipe';
import { BillingsComponent } from './pages/billings/billings.component';
import { IsExistsPipe } from './pipes/is-exists.pipe';
import { GetValuePipe } from './pipes/get-value.pipe';
import { ReceiptTemplateComponent } from './popups/receipt-template/receipt-template.component';
import { GlobalConfigComponent } from './pages/global-config/global-config.component';
import { GlobalConfigEditComponent } from './popups/global-config-edit/global-config-edit.component';
import { SearchComponent } from './pages/search/search.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { PricingContainerComponent } from './shared/pricing-container/pricing-container.component';
import { FieldsConfigComponent } from './pages/fields-config/fields-config.component';
import { FieldConfigComponent } from './popups/field-config/field-config.component';
import { SupportingLinesComponent } from './shared/supporting-lines/supporting-lines.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { DeletedItemsComponent } from './popups/deleted-items/deleted-items.component';
import { RelationshipsComponent } from './pages/relationships/relationships.component';
import { EditRelationshipComponent } from './popups/edit-relationship/edit-relationship.component';
import { SummaryComponent } from './popups/summary/summary.component';
import { EditCreditsComponent } from './popups/edit-credits/edit-credits.component';
import { PagingComponent } from './shared/paging/paging.component';
import { UsersComponent } from './pages/users/users.component';
import { GlobalLocationsComponent } from './shared/global-locations/global-locations.component';
import { GraphComponent } from './shared/graph/graph.component';
import { RequestsComponent } from './pages/requests/requests.component';
import { SellersAdminComponent } from './pages/sellers-admin/sellers-admin.component';
import { MyPaymentsComponent } from './pages/my-payments/my-payments.component';
import { DelivererComponent } from './pages/deliverer/deliverer.component';
import { DelivererConfigComponent } from './popups/deliverer-config/deliverer-config.component';
import { WorkingHoursRangeComponent } from './shared/working-hours-range/working-hours-range.component';
import { TimePickerComponent } from './shared/time-picker/time-picker.component';
import { PagingSearchFilterComponent } from './shared/paging-search-filter/paging-search-filter.component';
import { HtmlViewerComponent } from './popups/html-viewer/html-viewer.component';
import { PrintReceiptComponent } from './shared/print-receipt/print-receipt.component';
import { PrintComponent } from './shared/print/print.component';
import { BarcodeGeneratorComponent } from './popups/barcode-generator/barcode-generator.component';
import { QrcodeGeneratorComponent } from './shared/qrcode-generator/qrcode-generator.component';
import { QrcodeComponent } from './pages/qrcode/qrcode.component';
import { UserComponent } from './pages/user/user.component';
import { EditSystemInfoComponent } from './popups/edit-system-info/edit-system-info.component';
import { EditAdditionalDetailsComponent } from './popups/edit-additional-details/edit-additional-details.component';
import { UsersAccessComponent } from './pages/users-access/users-access.component';
import { MyAccessComponent } from './pages/my-access/my-access.component';
import { AddAccessComponent } from './popups/add-access/add-access.component';
import { LeftRightSelectionComponent } from './shared/left-right-selection/left-right-selection.component';
import { AllowedActionsComponent } from './pages/allowed-actions/allowed-actions.component';
import { GuideComponent } from './pages/guide/guide.component';
import { GuideConfigComponent } from './popups/guide-config/guide-config.component';
import { LanguageSingleComponent } from './shared/language-single/language-single.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { FileUploadComponent } from './shared/file-upload/file-upload.component';
import { ViewImageComponent } from './shared/view-image/view-image.component';
import { AppointmentsComponent } from './pages/appointments/appointments.component';
import { EditAppointmentComponent } from './popups/edit-appointment/edit-appointment.component';
import { BusinessRelationshipComponent } from './shared/business-relationship/business-relationship.component';
import { ProductCategoriesComponent } from './pages/product-categories/product-categories.component';
import { ProductCategoryConfigComponent } from './popups/product-category-config/product-category-config.component';
import { SelectedBusinessTitleComponent } from './shared/selected-business-title/selected-business-title.component';
import { StartupConfigsComponent } from './pages/startup-configs/startup-configs.component';
import { EditStartupConfigComponent } from './popups/edit-startup-config/edit-startup-config.component';
import { ReturnProductsComponent } from './popups/return-products/return-products.component';
import { ConfigSerialNumbersComponent } from './popups/config-serial-numbers/config-serial-numbers.component';
import { SerialNumbersComponent } from './pages/serial-numbers/serial-numbers.component';
import { SerialNumbersMappingComponent } from './popups/serial-numbers-mapping/serial-numbers-mapping.component';
import { ProductValidationComponent } from './popups/product-validation/product-validation.component';
import { SelectBusinessComponent } from './popups/select-business/select-business.component';
import { BusinessPaymentsComponent } from './shared/business-payments/business-payments.component';
import { SmsReportComponent } from './pages/sms-report/sms-report.component';
import { SalesReportComponent } from './pages/sales-report/sales-report.component';
import { SearchTokenComponent } from './shared/search-token/search-token.component';
import { PricingCalculatorComponent } from './pages/pricing-calculator/pricing-calculator.component';
import { ComplaintsComponent } from './pages/complaints/complaints.component';
import { BusinessDeductiveComponent } from './shared/business-deductive/business-deductive.component';
import { ListOptionsComponent } from './shared/list-options/list-options.component';
import { WhitelistsComponent } from './pages/whitelists/whitelists.component';
import { WhitelistConfigComponent } from './popups/whitelist-config/whitelist-config.component';
import { CountryContactComponent } from './shared/country-contact/country-contact.component';
import { PopupHeaderComponent } from './shared/popup-header/popup-header.component';
import { WhitelistAccessComponent } from './pages/whitelist-access/whitelist-access.component';
import { HttpRequestComponent } from './shared/http-request/http-request.component';
import { InformationComponent } from './popups/information/information.component';
import { DeviceInformationComponent } from './pages/device-information/device-information.component';
import { ProgressBarComponent } from './shared/progress-bar/progress-bar.component';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { FullPageMessageComponent } from './shared/full-page-message/full-page-message.component';
import { PageKeyAccessComponent } from './pages/page-key-access/page-key-access.component';
import { MenuPagekeyComponent } from './popups/menu-pagekey/menu-pagekey.component';
import { QrScannerComponent } from './shared/qr-scanner/qr-scanner.component';
import { ProductLogsComponent } from './pages/product-logs/product-logs.component';
import { ProductLogDetailsComponent } from './pages/product-log-details/product-log-details.component';
import { CreditLogsComponent } from './popups/credit-logs/credit-logs.component';
import { SmsSettingsComponent } from './popups/sms-settings/sms-settings.component';
import { AddMessageCreditsComponent } from './popups/add-message-credits/add-message-credits.component';
import { LessCreditsComponent } from './popups/less-credits/less-credits.component';
import { ToolPricingConfigComponent } from './popups/tool-pricing-config/tool-pricing-config.component';
import { NewComplaintComponent } from './popups/new-complaint/new-complaint.component';
import { InternetCheckComponent } from './shared/internet-check/internet-check.component';
import { PrepaidComponent } from './pages/prepaid/prepaid.component';
import { LabelComponent } from './shared/label/label.component';
import { PaymentsComponent } from './shared/payments/payments.component';
import { PaymentGatewayComponent } from './pages/payment-gateway/payment-gateway.component';
import { CustomizeMenuComponent } from './pages/customize-menu/customize-menu.component';
import { PayFromWalletComponent } from './popups/pay-from-wallet/pay-from-wallet.component';
import { PaidByCompanyComponent } from './pages/paid-by-company/paid-by-company.component';
import { PrepaidPinComponent } from './shared/prepaid-pin/prepaid-pin.component';
import { WorkingAsComponent } from './shared/working-as/working-as.component';
import { AssociatedAccountsComponent } from './popups/associated-accounts/associated-accounts.component';
import { DummyGraphComponent } from './shared/dummy-graph/dummy-graph.component';
import { DummyBillComponent } from './shared/dummy-bill/dummy-bill.component';
import { FactsComponent } from './shared/facts/facts.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { SeatReservationComponent } from './pages/seat-reservation/seat-reservation.component';
import { SeatReservationConfigComponent } from './popups/seat-reservation-config/seat-reservation-config.component';
import { SeatArrangementsComponent } from './shared/seat-arrangements/seat-arrangements.component';
import { SessionConfigComponent } from './popups/session-config/session-config.component';
import { SeatsBillingComponent } from './popups/seats-billing/seats-billing.component';
import { SeatsQueueComponent } from './popups/seats-queue/seats-queue.component';
import { BillHistoryComponent } from './popups/bill-history/bill-history.component';
import { CommentComponent } from './popups/comment/comment.component';
import { GetStartedComponent } from './pages/get-started/get-started.component';
import { TipsComponent } from './pages/tips/tips.component';
import { ReferComponent } from './pages/refer/refer.component';
import { LanguageContainerConfigComponent } from './popups/language-container-config/language-container-config.component';
import { LogsComponent } from './pages/logs/logs.component';
import { LanguageHistoryComponent } from './popups/language-history/language-history.component';
import { OtpPadComponent } from './shared/otp-pad/otp-pad.component';
import { LiveTokensComponent } from './pages/live-tokens/live-tokens.component';
import { ManageServiceComponent } from './pages/manage-service/manage-service.component';
import { ActivateServiceComponent } from './shared/activate-service/activate-service.component';
import { RefundConfigComponent } from './popups/refund-config/refund-config.component';
import { RefundComponent } from './pages/refund/refund.component';
import { RentReciptLogsComponent } from './pages/rent-recipt-logs/rent-recipt-logs.component';
import { UsageLimitsComponent } from './popups/usage-limits/usage-limits.component';
import { BulkSerialNumbersComponent } from './popups/bulk-serial-numbers/bulk-serial-numbers.component';
import { BulkQrCodeComponent } from './popups/bulk-qr-code/bulk-qr-code.component';
import { DatePickerComponent } from './shared/date-picker/date-picker.component';
import { TemplateIdsComponent } from './pages/template-ids/template-ids.component';
import { CanvasHeaderComponent } from './shared/popup-header/canvas-header/canvas-header.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { PaymentLinkComponent } from './popups/payment-link/payment-link.component';
import { BulkUploadComponent } from './popups/bulk-upload/bulk-upload.component';
import { RequestLogDetailsComponent } from './pages/request-log-details/request-log-details.component';
import { GalleryConfigComponent } from './popups/gallery-config/gallery-config.component';
import { GalleryBizComponent } from './pages/gallery-biz/gallery-biz.component';
import { MessageBoxComponent } from './shared/message-box/message-box.component';
import { GalleryViewerComponent } from './shared/gallery-viewer/gallery-viewer.component';
import { ReceiptOptionsComponent } from './popups/receipt-options/receipt-options.component';
import { ReceiptOptionsContentComponent } from './popups/receipt-options-content/receipt-options-content.component';
import { ReceiptOptionsHtmlComponent } from './shared/receipt-options-html/receipt-options-html.component';
import { ReceiptOptionsHtmlContentComponent } from './pages/receipt-options-html-content/receipt-options-html-content.component';
import { ReceiptViewComponent } from './pages/receipt-view/receipt-view.component';
import { ExploreProductsComponent } from './pages/explore-products/explore-products.component';
import { ItemsComponent } from './shared/items/items.component';
import { ProductDetailsComponent } from './popups/product-details/product-details.component';
import { TabComponent } from './shared/tab/tab.component';
import { BillTaxesComponent } from './shared/bill-taxes/bill-taxes.component';
import { SummaryDetailsComponent } from './popups/summary-details/summary-details.component';
import { WorkingHoursPopupComponent } from './popups/working-hours-popup/working-hours-popup.component';
import { PrintQrcodeComponent } from './popups/print-qrcode/print-qrcode.component';
import { GetPercentageValuePipe } from './pipes/get-percentage-value.pipe';
import { TextUpdateComponent } from './shared/text-update/text-update.component';
import { SuppliersComponent } from './pages/suppliers/suppliers.component';
import { PurchaseEntryDetailsComponent } from './pages/purchase-entry-details/purchase-entry-details.component';
import { PurchaseEntriesComponent } from './pages/purchase-entries/purchase-entries.component';
import { SupplierComponent } from './popups/supplier/supplier.component';
import { PurchaseEntryComponent } from './popups/purchase-entry/purchase-entry.component';
import { LookupsComponent } from './pages/lookups/lookups.component';
import { LookupEditComponent } from './popups/lookup-edit/lookup-edit.component';
import { LookupComponent } from './shared/lookup/lookup.component';
import { LocalPrinterComponent } from './pages/local-printer/local-printer.component';
import { PrinterDeviceMapComponent } from './shared/printer-device-map/printer-device-map.component';
import { PrinterTemplateMapComponent } from './shared/printer-template-map/printer-template-map.component';
import { AvailablePrintersComponent } from './shared/available-printers/available-printers.component';
import { DevicesComponent } from './shared/devices/devices.component';
import { TemplatesComponent } from './shared/templates/templates.component';
import { PrinterDeviceMapPopupComponent } from './popups/printer-device-map-popup/printer-device-map-popup.component';
import { PrinterDevicePopupComponent } from './popups/printer-device-popup/printer-device-popup.component';
import { PrinterTemplateMapPopupComponent } from './popups/printer-template-map-popup/printer-template-map-popup.component';
import { ReceiptTemplatePopupComponent } from './popups/receipt-template-popup/receipt-template-popup.component';
import { BillingAdjustFormulaComponent } from './popups/billing-adjust-formula/billing-adjust-formula.component';
import { PlanPurchaseDetailComponent } from './pages/plan-purchase-detail/plan-purchase-detail.component';
import { PlanPurchaseComponent } from './pages/plan-purchase/plan-purchase.component';
import { PlanPurchaseDetailEditComponent } from './popups/plan-purchase-detail-edit/plan-purchase-detail-edit.component';
import { BatchEntriesComponent } from './pages/batch-entries/batch-entries.component';
import { BatchEntryDetailsComponent } from './pages/batch-entry-details/batch-entry-details.component';
import { BatchEntryComponent } from './popups/batch-entry/batch-entry.component';
import { BatchInventoriesComponent } from './pages/batch-inventories/batch-inventories.component';
import { BatchPricingComponent } from './popups/batch-pricing/batch-pricing.component';
import { QrPaymentLogsComponent } from './pages/qr-payment-logs/qr-payment-logs.component';
import { QrGeneratorSimpleComponent } from './popups/qr-generator-simple/qr-generator-simple.component';
import { CustomPrintLabelComponent } from './pages/custom-print-label/custom-print-label.component';
import { CustomLabelPrintConfigComponent } from './popups/custom-label-print-config/custom-label-print-config.component';
import { FontSettingsConfigComponent } from './popups/font-settings-config/font-settings-config.component';
import { ReceiptIconConfigComponent } from './popups/receipt-icon-config/receipt-icon-config.component';
import { PaymentGatewayCustomerComponent } from './pages/payment-gateway-customer/payment-gateway-customer.component';
import { PaymentQrImageComponent } from './shared/payment-qr-image/payment-qr-image.component';
import { PaymentGatewaysConfigComponent } from './pages/payment-gateways-config/payment-gateways-config.component';
import { PaymentGatewayConfigComponent } from './pages/payment-gateway-config/payment-gateway-config.component';
import { EditPaymentGatewayConfigComponent } from './popups/edit-payment-gateway-config/edit-payment-gateway-config.component';
import { BillPaymentTypesComponent } from './popups/bill-payment-types/bill-payment-types.component';
import { QrLabelGeneratorComponent } from './pages/qr-label-generator/qr-label-generator.component';
import { QrLabelTemplateConfigComponent } from './pages/qr-label-template-config/qr-label-template-config.component'; import { LabelVariableConfigComponent } from './popups/label-variable-config/label-variable-config.component';
import { QrLabelPreviewSettingsComponent } from './popups/qr-label-preview-settings/qr-label-preview-settings.component';
import { QrLabelUploadComponent } from './pages/qr-label-upload/qr-label-upload.component';
import { CustomFieldsConfigComponent } from './popups/custom-fields-config/custom-fields-config.component';
import { ReceiptHtmlComponent } from './pages/receipt-html/receipt-html.component';
import { PurchaseEntryHistoriesComponent } from './popups/purchase-entry-histories/purchase-entry-histories.component';
import { ProductChildMeasurementComponent } from './popups/product-child-measurement/product-child-measurement.component';
import { BillStaffComponent } from './shared/bill-staff/bill-staff.component';
import { SettlementReportComponent } from './pages/settlement-report/settlement-report.component';
import { LinkBusinessesComponent } from './pages/link-businesses/link-businesses.component';
import { AuthConfigsComponent } from './pages/auth-configs/auth-configs.component';
import { ReceiptFilesComponent } from './pages/receipt-files/receipt-files.component';
import { B2bAccountsComponent } from './pages/b2b-accounts/b2b-accounts.component';
import { B2bAccountComponent } from './popups/b2b-account/b2b-account.component';
import { B2bOwnerComponent } from './popups/b2b-owner/b2b-owner.component';
import { PickBusinessComponent } from './shared/pick-business/pick-business.component';
import { SendToPhoneComponent } from './shared/send-to-phone/send-to-phone.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { TaskRequestsComponent } from './pages/task-requests/task-requests.component';
import { TaskRequestComponent } from './popups/task-request/task-request.component';
import { ExpensesComponent } from './pages/expenses/expenses.component';
import { ProductsActionComponent } from './popups/products-action/products-action.component';
import { OverwritePriceComponent } from './popups/overwrite-price/overwrite-price.component';
import { MoreActionsComponent } from './popups/more-actions/more-actions.component';
import { ReceiptCustomLabelsComponent } from './pages/receipt-custom-labels/receipt-custom-labels.component';
import { CapturePhotoComponent } from './shared/capture-photo/capture-photo.component';
import { B2bLicensesComponent } from './pages/b2b-licenses/b2b-licenses.component';
import { OverwriteDiscountComponent } from './popups/overwrite-discount/overwrite-discount.component';
import { BaseAmountConversionComponent } from './pages/base-amount-conversion/base-amount-conversion.component';
import { RawMaterialInventoryConfigComponent } from './popups/raw-material-inventory-config/raw-material-inventory-config.component';
import { BizSubscriptionsComponent } from './pages/biz-subscriptions/biz-subscriptions.component';
import { CreateNoConfigBillComponent } from './pages/create-no-config-bill/create-no-config-bill.component';
import { ViewNoConfigBillComponent } from './pages/view-no-config-bill/view-no-config-bill.component';
import { NoConfigBillSettingsComponent } from './popups/no-config-bill-settings/no-config-bill-settings.component';
import { CloneBusinessComponent } from './shared/clone-business/clone-business.component';
import { DeviceNetworkSettingsComponent } from './pages/device-network-settings/device-network-settings.component';
import { ConfigMachineComponent } from './popups/config-machine/config-machine.component';
import { ConfigUiDeviceComponent } from './popups/config-ui-device/config-ui-device.component';
import { ReceiptTemplatesComponent } from './pages/receipt-templates/receipt-templates.component';
import { ReceiptTemplateSelectorComponent } from './shared/receipt-template-selector/receipt-template-selector.component';

@NgModule({
  declarations: [
    AppComponent,
    SafePipe,
    DefaultComponent,
    LoginComponent,
    HeaderComponent,
    LanguageConfigComponent,
    LanguageComponent,
    LanguageSelectionComponent,
    CreateAccountComponent,
    LanguageContentsAllComponent,
    LanguagesContentComponent,
    MessageComponent,
    LanguageSectionConfigComponent,
    OtpContainerComponent,
    PwdChangeComponent,
    StartupComponent,
    LanguageContainerComponent,
    MenusComponent,
    MenuConfigurationComponent,
    CountriesComponent,
    CountryConfigurationComponent,
    LocationsComponent,
    LocationConfigurationComponent,
    SellerComponent,
    GeneralConfigurationComponent,
    GeneralConfigurationPopupComponent,
    SellersComponent,
    MappingContainerComponent,
    LocalLocationsComponent,
    UserAuthenticationComponent,
    ProductsComponent,
    BillingComponent,
    SumPipe,
    BillingsComponent,
    IsExistsPipe,
    GetValuePipe,
    ReceiptTemplateComponent,
    GlobalConfigComponent,
    GlobalConfigEditComponent,
    SearchComponent,
    SettingsComponent,
    PricingContainerComponent,
    FieldsConfigComponent,
    FieldConfigComponent,
    SupportingLinesComponent,
    SpinnerComponent,
    NotificationsComponent,
    DeletedItemsComponent,
    RelationshipsComponent,
    EditRelationshipComponent,
    SummaryComponent,
    EditCreditsComponent,
    PagingComponent,
    UsersComponent,
    GlobalLocationsComponent,
    GraphComponent,
    RequestsComponent,
    SellersAdminComponent,
    MyPaymentsComponent,
    DelivererComponent,
    DelivererConfigComponent,
    WorkingHoursRangeComponent,
    TimePickerComponent,
    PagingSearchFilterComponent,
    HtmlViewerComponent,
    PrintReceiptComponent,
    PrintComponent,
    BarcodeGeneratorComponent,
    QrcodeGeneratorComponent,
    QrcodeComponent,
    UserComponent,
    EditSystemInfoComponent,
    EditAdditionalDetailsComponent,
    UsersAccessComponent,
    MyAccessComponent,
    AddAccessComponent,
    LeftRightSelectionComponent,
    AllowedActionsComponent,
    GuideComponent,
    GuideConfigComponent,
    LanguageSingleComponent,
    GalleryComponent,
    FileUploadComponent,
    ViewImageComponent,
    AppointmentsComponent,
    EditAppointmentComponent,
    BusinessRelationshipComponent,
    ProductCategoriesComponent,
    ProductCategoryConfigComponent,
    SelectedBusinessTitleComponent,
    StartupConfigsComponent,
    EditStartupConfigComponent,
    ReturnProductsComponent,
    ConfigSerialNumbersComponent,
    SerialNumbersComponent,
    SerialNumbersMappingComponent,
    ProductValidationComponent,
    SelectBusinessComponent,
    BusinessPaymentsComponent,
    SmsReportComponent,
    SalesReportComponent,
    SearchTokenComponent,
    PricingCalculatorComponent,
    ComplaintsComponent,
    BusinessDeductiveComponent,
    ListOptionsComponent,
    WhitelistsComponent,
    WhitelistConfigComponent,
    CountryContactComponent,
    PopupHeaderComponent,
    WhitelistAccessComponent,
    HttpRequestComponent,
    InformationComponent,
    DeviceInformationComponent,
    ProgressBarComponent,
    LocalDatePipe,
    FullPageMessageComponent,
    PageKeyAccessComponent,
    MenuPagekeyComponent,
    QrScannerComponent,
    ProductLogsComponent,
    ProductLogDetailsComponent,
    CreditLogsComponent,
    SmsSettingsComponent,
    AddMessageCreditsComponent,
    LessCreditsComponent,
    ToolPricingConfigComponent,
    NewComplaintComponent,
    InternetCheckComponent,
    PrepaidComponent,
    LabelComponent,
    PaymentsComponent,
    PaymentGatewayComponent,
    CustomizeMenuComponent,
    PayFromWalletComponent,
    PaidByCompanyComponent,
    PrepaidPinComponent,
    WorkingAsComponent,
    AssociatedAccountsComponent,
    DummyGraphComponent,
    DummyBillComponent,
    FactsComponent,
    RedirectComponent,
    SeatReservationComponent,
    SeatReservationConfigComponent,
    SeatArrangementsComponent,
    SessionConfigComponent,
    SeatsBillingComponent,
    SeatsQueueComponent,
    BillHistoryComponent,
    CommentComponent,
    GetStartedComponent,
    TipsComponent,
    ReferComponent,
    LanguageContainerConfigComponent,
    LogsComponent,
    LanguageHistoryComponent,
    OtpPadComponent,
    LiveTokensComponent,
    ManageServiceComponent,
    ActivateServiceComponent,
    RefundConfigComponent,
    RefundComponent,
    RentReciptLogsComponent,
    UsageLimitsComponent,
    BulkSerialNumbersComponent,
    BulkQrCodeComponent,
    DatePickerComponent,
    TemplateIdsComponent,
    CanvasHeaderComponent,
    PaymentLinkComponent,
    BulkUploadComponent,
    RequestLogDetailsComponent,
    GalleryConfigComponent,
    GalleryBizComponent,
    MessageBoxComponent,
    GalleryViewerComponent,
    ReceiptOptionsComponent,
    ReceiptOptionsContentComponent,
    ReceiptOptionsHtmlComponent,
    ReceiptOptionsHtmlContentComponent,
    ReceiptViewComponent,
    ExploreProductsComponent,
    ItemsComponent,
    ProductDetailsComponent,
    TabComponent,
    BillTaxesComponent,
    SummaryDetailsComponent,
    WorkingHoursPopupComponent,
    PrintQrcodeComponent,
    GetPercentageValuePipe,
    TextUpdateComponent,
    SuppliersComponent,
    PurchaseEntriesComponent,
    PurchaseEntryDetailsComponent,
    SupplierComponent,
    PurchaseEntryComponent,
    LookupsComponent,
    LookupEditComponent,
    LookupComponent,
    LocalPrinterComponent,
    PrinterDeviceMapComponent,
    PrinterTemplateMapComponent,
    AvailablePrintersComponent,
    DevicesComponent,
    TemplatesComponent,
    PrinterDeviceMapPopupComponent,
    PrinterDevicePopupComponent,
    PrinterTemplateMapPopupComponent,
    ReceiptTemplatePopupComponent,
    BillingAdjustFormulaComponent,
    PlanPurchaseDetailComponent,
    PlanPurchaseComponent,
    PlanPurchaseDetailEditComponent,
    BatchEntriesComponent,
    BatchEntryDetailsComponent,
    BatchEntryComponent,
    BatchInventoriesComponent,
    BatchPricingComponent,
    QrPaymentLogsComponent,
    QrGeneratorSimpleComponent,
    CustomPrintLabelComponent,
    CustomLabelPrintConfigComponent,
    FontSettingsConfigComponent,
    ReceiptIconConfigComponent,
    PaymentGatewayCustomerComponent,
    PaymentQrImageComponent,
    PaymentGatewaysConfigComponent,
    PaymentGatewayConfigComponent,
    EditPaymentGatewayConfigComponent,
    BillPaymentTypesComponent,
    QrLabelGeneratorComponent,
    QrLabelTemplateConfigComponent,
    LabelVariableConfigComponent,
    DeviceNetworkSettingsComponent,
    QrLabelPreviewSettingsComponent,
    QrLabelUploadComponent,
    CustomFieldsConfigComponent,
    ReceiptHtmlComponent,
    PurchaseEntryHistoriesComponent,
    ProductChildMeasurementComponent,
    BillStaffComponent,
    SettlementReportComponent,
    LinkBusinessesComponent,
    AuthConfigsComponent,
    ReceiptFilesComponent,
    B2bAccountsComponent,
    B2bAccountComponent,
    B2bOwnerComponent,
    PickBusinessComponent,
    SendToPhoneComponent,
    InvoicesComponent,
    TaskRequestsComponent,
    TaskRequestComponent,
    ExpensesComponent,
    ProductsActionComponent,
    OverwritePriceComponent,
    MoreActionsComponent,
    ReceiptCustomLabelsComponent,
    CapturePhotoComponent,
    B2bLicensesComponent,
    OverwriteDiscountComponent,
    BaseAmountConversionComponent,
    RawMaterialInventoryConfigComponent,
    BizSubscriptionsComponent,
    CreateNoConfigBillComponent,
    ViewNoConfigBillComponent,
    NoConfigBillSettingsComponent,
    CloneBusinessComponent,
    ConfigMachineComponent,
    ConfigUiDeviceComponent,
    ReceiptTemplatesComponent,
    ReceiptTemplateSelectorComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    NgxSelectModule,
    NgbModule,
    FormsModule,
    QRCodeModule,
    NgxScannerQrcodeModule,
    NgChartsModule,
    GooglePayButtonModule,
    NgbCarouselModule
  ],
  providers: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
